import { LoaderFunctionArgs, RouteObject } from 'react-router';

import { Public } from '@/ui/pages/external/venue/structure/public/Public';
import { PublicCatering } from '@/ui/pages/external/venue/structure/public-catering/PublicCatering';
import { PublicDigital } from '@/ui/pages/external/venue/structure/public-digital/PublicDigital';
import { Site } from '@/ui/pages/external/venue/structure/site/Site';
import { SiteBuilding } from '@/ui/pages/external/venue/structure/site-building/SiteBuilding';
import { SiteEnergy } from '@/ui/pages/external/venue/structure/site-energy/SiteEnergy';
import { SiteEquipment } from '@/ui/pages/external/venue/structure/site-equipment/SiteEquipment';
import { SiteMaterial } from '@/ui/pages/external/venue/structure/site-material/SiteMaterial';
import { SiteScenography } from '@/ui/pages/external/venue/structure/site-scenography/SiteScenography';
import { SiteWaste } from '@/ui/pages/external/venue/structure/site-waste/SiteWaste';
import { SiteWater } from '@/ui/pages/external/venue/structure/site-water/SiteWater';
import { Team } from '@/ui/pages/external/venue/structure/team/Team';
import { TeamCatering } from '@/ui/pages/external/venue/structure/team-catering/TeamCatering';
import { TeamTransport } from '@/ui/pages/external/venue/structure/team-transport/TeamTransport';

import { externalLoader } from '../externalLoaders';

export const externalVenueStructureRoutes: RouteObject[] = [
  // Venue structure: full form
  {
    path: 'venue-structure-site',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-SITE' }),
    element: <Site />,
  },
  {
    path: 'venue-structure-team',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-TEAM' }),
    element: <Team />,
  },
  {
    path: 'venue-structure-public',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-PUBLIC' }),
    element: <Public />,
  },
  // Venue structure: site-categories
  {
    path: 'venue-structure-site-scenography',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-STRUCTURE-SITE-SCENOGRAPHY',
      }),
    element: <SiteScenography />,
  },
  {
    path: 'venue-structure-site-material',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-SITE-MATERIAL' }),
    element: <SiteMaterial />,
  },
  {
    path: 'venue-structure-site-building',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-SITE-BUILDING' }),
    element: <SiteBuilding />,
  },
  {
    path: 'venue-structure-site-energy',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-SITE-ENERGY' }),
    element: <SiteEnergy />,
  },
  {
    path: 'venue-structure-site-water',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-SITE-WATER' }),
    element: <SiteWater />,
  },
  {
    path: 'venue-structure-site-waste',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'VENUE-STRUCTURE-SITE-WASTE' }),
    element: <SiteWaste />,
  },
  {
    path: 'venue-structure-site-equipment',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-STRUCTURE-SITE-EQUIPMENT',
      }),
    element: <SiteEquipment />,
  },
  {
    path: 'venue-structure-public-catering',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-STRUCTURE-PUBLIC-CATERING',
      }),
    element: <PublicCatering />,
  },
  {
    path: 'venue-structure-public-digital',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-STRUCTURE-PUBLIC-DIGITAL',
      }),
    element: <PublicDigital />,
  },
  // Venue structure: team-categories
  {
    path: 'venue-structure-team-transport',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-STRUCTURE-TEAM-TRANSPORT',
      }),
    element: <TeamTransport />,
  },
  {
    path: 'venue-structure-team-catering',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, {
        allowedScope: 'VENUE-STRUCTURE-TEAM-CATERING',
      }),
    element: <TeamCatering />,
  },
];
